export default "__VITE_ASSET__BQXbM$g$__"